//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'LandingSignup',
  methods: {
    openTab () {
      const routeData = this.$router.resolve({ path: '/my/auth/register' })
      window.open(routeData.href, '_blank')
    }
  }
}
